/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/sketch";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/sketch";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { CutShape } from "api/types/sketch";
/// URLS ///
import { url_prefix } from "settings";
import { cut_shape_bulk_url } from "../endpoint";

export const createBulkCutShapes = (cut_shapes: CutShape[]) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SKETCH_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${cut_shape_bulk_url}/`;

    try {
      await axios.post(url, cut_shapes, config);

      dispatch({
        type: ActionType.SKETCH_ACTION_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SKETCH_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
